import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const FormsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Forms",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.51 30h10.34c.83 0 1.5-.67 1.5-1.51V23.5c0-.83-.67-1.5-1.5-1.5H3.51c-.83 0-1.5.67-1.5 1.51v4.99c0 .83.67 1.5 1.5 1.5m1.5-4.99h7.34v2H5.01zm-1.5-5H28.5c.83 0 1.5-.67 1.51-1.49v-5.01c0-.83-.67-1.5-1.51-1.5h-25c-.83 0-1.5.67-1.5 1.5v4.99c0 .83.67 1.5 1.5 1.5Zm1.5-4.99h21.98v1.99H5.01zm-1.5-5H28.5c.83 0 1.5-.67 1.51-1.49V3.51c0-.83-.67-1.5-1.51-1.5h-25c-.83 0-1.5.67-1.5 1.5v5C2 9.34 2.68 10 3.5 10Zm1.5-4.99h21.98v1.99H5.01zm13.15 16.99h10.33c.83 0 1.51.67 1.51 1.51v4.98c0 .83-.67 1.51-1.51 1.51H18.16a1.5 1.5 0 0 1-1.5-1.51v-4.98c0-.83.67-1.51 1.5-1.51"
    })
  }));
};